<div class="d-flex align-items-center" *ngIf="message" [ngClass]="message.cssClass">
  {{ message.text }}
  <button type="button" class="btn border-0 m-0 p-0 h-fit-content d-flex ms-auto" data-dismiss="alert"
    aria-label="Close" (click)="close()">
    <span class="material-icons-outlined">close</span>
  </button>
</div>
